/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GnlList } from '../../models/gnl-list';
import { GnlSearchBody } from '../../models/gnl-search-body';
import { SortDirection } from '../../models/sort-direction';

export interface SearchGnl$Json$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates the field to use for sorting the data:
 *   * NAME : the station's name
 */
  sortFieldName?: 'NAME';

/**
 * The date time for the tank level
 */
  levelDateTime?: string;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;
  
    /**
     * Body for search GNL
     */
    body?: GnlSearchBody
}

export function searchGnl$Json(http: HttpClient, rootUrl: string, params?: SearchGnl$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GnlList>> {
  const rb = new RequestBuilder(rootUrl, searchGnl$Json.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('levelDateTime', params.levelDateTime, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GnlList>;
    })
  );
}

searchGnl$Json.PATH = '/custom/dashboard/gnl/search';
